/**
 * Utility functions for blueprint operations
 */

interface BlueprintImageConfig {
  dir: string;
  favIcon: string;
  banner: string;
}

/**
 * Mapping of blueprint names to their image assets
 */
const BLUEPRINT_IMAGE_MAP: Record<string, BlueprintImageConfig> = {
  'Qwen3 30B A3B': {
    dir: 'qwen3_30b_a3b',
    favIcon: 'qwen-fav.png',
    banner: 'qwen3-banner.png',
  },
  'Gemma3-27b': {
    dir: 'gemma3_27b',
    favIcon: 'gemma-fav.png',
    banner: 'gemma-banner.png',
  },
  'Typhoon2.1-gemma3-12b': {
    dir: 'typhoon2.1-gemma3-12b',
    favIcon: 'typhoon-fav.png',
    banner: 'typhoon-banner.webp',
  },
  'Thai Document OCR': {
    dir: 'thai-document-ocr',
    favIcon: 'document-fav.png',
    banner: 'document-banner.jpg',
  },
  'Parabricks fq2bam': {
    dir: 'parabricks',
    favIcon: 'parabricks-fav.png',
    banner: 'parabricks-banner.jpeg',
  },
};

/**
 * Cache busting version - increment this when images change
 */
const IMAGE_VERSION = 'v3';

/**
 * Get blueprint image paths
 * @param blueprintName - The name of the blueprint
 * @returns Object containing paths to fav and banner images, or null if not found
 */
export const getBlueprintImages = (
  blueprintName: string
): {
  favIcon: string | null;
  banner: string | null;
} => {
  const config = BLUEPRINT_IMAGE_MAP[blueprintName];

  if (!config) {
    return {
      favIcon: null,
      banner: null,
    };
  }

  return {
    favIcon: `/image/blueprint/${config.dir}/${config.favIcon}?v=${IMAGE_VERSION}`,
    banner: `/image/blueprint/${config.dir}/${config.banner}?v=${IMAGE_VERSION}`,
  };
};
